import {AuthStates} from '../../types/types';

const checkIsSignedIn = (authState: AuthStates): boolean => (
    authState === AuthStates.authenticated
    || authState === AuthStates.verifyContact
);

export default checkIsSignedIn;
